// extracted by mini-css-extract-plugin
module.exports = {"details":"details_details__fvulO"};